module.exports = __webpack_public_path__ + "static/pic01-b44c9b9c0f30ec0c5c746360ad0b3421.jpg";